import {INotification} from '@dev-fast/types';

export interface NotificationsStateModel {
  items: INotification[];
}

export const NOTIFICATIONS_INITIAL_STATE: NotificationsStateModel = {
  items: [],
};
